import { html } from '@shared/utils/rendering/html';
import Table from '@shared/components/tables';
import {
    SarbQuestionsColumns,
    SarbQuestionsTableFilters,
} from '@core/configs/tables/dashboard/sarb-questions-table.config';
import './sarb-questions-table.scss';

export const SarbQuestionsTable = ({
    rows = [],
    total = 0,
    isLoading = false,
    paginationData = { pageNumber: 1, pageSize: 10, total: 0 },
    onPaginate,
    onSortChange,
}) => {
    const config = {
        columns: SarbQuestionsColumns,
        filters: SarbQuestionsTableFilters(onPaginate, paginationData, onSortChange),
        noResultsMessage: 'No questions match the current filters.',
        loadingTitle: 'Loading questions',
    };

    // Venus Table skips the converter for null values and renders "N/A".
    // Normalise null/undefined rating to 0 so getRatingBand returns "Not Assessed".
    const normalizedRows = rows.map((row) => ({
        ...row,
        rating: row.rating ?? 0,
    }));

    const data = {
        rows: normalizedRows,
        total,
        isLoading,
    };

    return html`<${Table} config=${config} data=${data} />`;
};
